import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import Question from './Question'
import { useQuery } from '@tanstack/react-query'
import { apiGet } from '~/util/api'
import { useTranslation } from '~/hooks/useTranslation'

const Questions = () => {
  const { t } = useTranslation('Questions')
  const { uiState } = usePracticeInterviewing()
  const { data, error } = useQuery({
    queryKey: ['interviewResponses', uiState.documentId],
    queryFn: () =>
      apiGet(`/interview/practice_interviewing/${uiState.documentId}.json`),
    enabled: !!uiState.documentId,
  })

  const interviewResponses = data?.data?.interviewResponses || []
  if (error) {
    console.error('Error fetching interview responses:', error)
    return <div>{t('error_loading')}</div>
  }
  return (
    <>
      {interviewResponses.map((response, index) => {
        return (
          uiState.questionIndex === index && (
            <Question
              key={`interview-response-question-${response.id}`}
              response={response}
              index={index}
            />
          )
        )
      })}
    </>
  )
}

export default Questions
